import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-getsession/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
resetAction as SubjectSeletcedReset
} from 'one-state-subjectselected/src/actions';

import {
resetAction as SourceSelectedReset
} from 'one-state-sourceselected/src/actions'

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
    GETSESSION_FETCH = "one-state-getsession/fetch"
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of GetSession
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetSessionEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,teamName, settings: {
            epicendpoints: {
                getsession, apitoken
            },
            uisettings: {
                dashboardapiconfig: {
                    getsession : getsessionApi
                }
            },
            compatible : { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETSESSION_FETCH),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient Medical history response
                 */
                let dataresponse: any = action.payload;

                const callGetSessionAPI = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const responsefromAPI = server.get({
                            headers: headers,
                            path: getsession + "?sessionKey=" + (datares?.sessionKey)
                        })
                            .then((responsegetsession: any) => responsegetsession)
                            .catch((getsessionres: any) => {
                                log.error(
                                    "ccw-gadget,getsession-epic",
                                    "getsession-epic", {
                                        getsessionres
                                }
                                );
                                let errorbuild: ErrorObject={
                                    source:"GetSession",
                                    type:"error",
                                    status:getsessionres?.status,
                                    erroritems:getsessionres?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,getsession-epic",
                            "getsession-epic response", {
                            responsefromAPI
                        });
                        return from(responsefromAPI)
                    } else {
                        return from([]);
                    }

                }
                //Calling callMedicalhistoryAPI function here
                //the reason is we need to use pipe function.
                if (!getsessionApi) return []
                return callGetSessionAPI(dataresponse).
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions:any =[
                                setAction(responseAfterTransform.getsession)
                            ];
                            if(responseAfterTransform.error){
                                actions.push(addAction(responseAfterTransform.error));
                                let disp: Disposition = { value: "2016" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.sessionKey;
                                disp.meta03 = responseAfterTransform?.error?.status;
                                disp.meta04 = responseAfterTransform?.error?.erroritems[0]?.error_detail
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "2017" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.sessionKey;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
export const clearGetSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, getsession-epic",
            "clear-getsession-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSubSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSub-epic",
            "clear-selectedSub-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SubjectSeletcedReset())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSourceSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSource-epic",
            "clear-selectedSource-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SourceSelectedReset())
        )

    }
);